import { Extension } from '@tiptap/core';
import { PluginKey } from '@tiptap/pm/state';
import Suggestion from '@tiptap/suggestion';
import { isSuggestionQueryDismissed } from '../suggestion-allow';
import { filterSlashCommandItems } from './filter';
import { getSlashCommandItems } from './registry';
const SlashCommandPluginKey = new PluginKey('slash-command');
const createState = (props) => ({
    editor: props.editor,
    range: props.range,
    query: props.query,
    items: props.items,
    command: props.command,
    clientRect: props.clientRect,
});
export const SlashCommandExtension = Extension.create({
    name: 'slash-command',
    addOptions() {
        return {
            getHelpers: () => ({}),
            onUpdate: () => undefined,
            onExit: () => undefined,
            onKeyDown: () => false,
        };
    },
    addProseMirrorPlugins() {
        return [
            Suggestion({
                pluginKey: SlashCommandPluginKey,
                editor: this.editor,
                char: '/',
                allowSpaces: true,
                startOfLine: false,
                allow: ({ state, range }) => {
                    const $from = state.doc.resolve(range.from);
                    const parent = $from.parent;
                    // Avoid showing the slash menu inside code blocks or uneditable nodes.
                    if (parent.type.spec.code === true) {
                        return false;
                    }
                    return !isSuggestionQueryDismissed(state, range, '/');
                },
                items: ({ editor, query }) => {
                    const helpers = this.options.getHelpers();
                    const additionalItems = this.options.getAdditionalItems?.() ?? [];
                    const available = getSlashCommandItems({
                        editor,
                        helpers,
                        additionalItems,
                    });
                    return filterSlashCommandItems(available, query);
                },
                render: () => ({
                    onStart: (props) => {
                        this.options.onUpdate(createState(props));
                    },
                    onUpdate: (props) => {
                        this.options.onUpdate(createState(props));
                    },
                    onKeyDown: (props) => {
                        return this.options.onKeyDown(props);
                    },
                    onExit: () => {
                        this.options.onExit();
                    },
                }),
                command: ({ editor, range, props, }) => {
                    const helpers = this.options.getHelpers();
                    editor.chain().focus().deleteRange(range).run();
                    let shouldClose = true;
                    const close = () => {
                        if (!shouldClose) {
                            return;
                        }
                        shouldClose = false;
                        this.options.onExit();
                    };
                    const handled = props.run({
                        editor,
                        range,
                        close,
                        helpers,
                    });
                    if (handled !== false) {
                        close();
                    }
                },
            }),
        ];
    },
});
